import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { SiteHeaderComponent } from './site-header/site-header.component';

@NgModule({
  imports: [CommonModule, RouterModule, SiteHeaderComponent, SiteFooterComponent],
  exports: [CommonModule, RouterModule, SiteHeaderComponent, SiteFooterComponent]
})
export class SharedModule {}
